import React, { useEffect, useState, useRef } from 'react';
import * as $ from 'jquery';
import { Link } from 'react-router-dom';
import { Tab, Tabs } from 'react-bootstrap';
import io from 'socket.io-client';
import { store as storeNotification } from 'react-notifications-component';

import { useSelector, useDispatch } from 'react-redux';
import { authenticationsCheckSession } from '../../redux/actions/authentications';

import api from '../../api';
import config from '../../api/config.json';
import ModalChangePassword from '../ModalChangePassword';
import ModalChangeImage from '../ModalChangeImage';

import CallHistory, { handleClickUpdateTableCallHistory } from './CallHistory';
import Extension from './Extension';
import Group from './Group';
import { idPermissionsGroup4Case } from '../../utils/defaultPermissions';

const Sidebar = () => {
  const notificationConfig = {
    container: 'top-center',
    animationIn: ['animated', 'fadeIn'],
    animationOut: ['animated', 'fadeOut'],
    dismiss: {
      duration: 1500,
      showIcon: true
    }
  };
  const dispatch = useDispatch();
  const avaliableAgentId = '5972571dbe9d01feb20f45b6';
  const defaultValueSelectExtension = { id: '', number: '' };
  const currentExtension = useRef();
  const groupsLoginLogout = useRef();
  const pauseSelected = useRef();
  const userName = useRef();
  const mainDptName = useRef();
  const clientNumber = useRef();
  const userStatus = useRef();
  const icoStatus = useRef();
  const sidebarHeader = useRef();
  const editIcon = useRef();
  const [extensionsLogged, setExtensionsLogged] = useState([]);
  const [groupsAvailable, setGroupsAvailable] = useState([]);
  const [tableDataCallHistory, setTableDataCallHistory] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [optionsStatus, setOptionsStatus] = useState([]);
  const [optionsExtensions, setOptionsExtensions] = useState([]);
  const [statusId, setStatusId] = useState(avaliableAgentId);
  const [extensionToLogin, setExtensionToLogin] = useState(
    defaultValueSelectExtension
  );
  const [imageKey, setImageKey] = useState(Date.now().toString());
  const sessionUser = useSelector(state => state.authentications.user);
  const { permissionsGroup } = sessionUser;
  const permissions =
    permissionsGroup && Array.isArray(permissionsGroup.permissions)
      ? [...permissionsGroup.permissions]
      : [];
  const [showModalChangePassword, setShowModalChangePassword] = useState(false);
  const handleModalCloseChangePassword = () =>
    setShowModalChangePassword(false);
  const [showModalChangeImage, setShowModalChangeImage] = useState(false);
  const handleModalCloseChangeImage = () => {
    setImageKey(Date.now().toString());
    setShowModalChangeImage(false);
  };

  const getAvailableExtensions = async () => {
    try {
      setIsFetching(true);
      const extensions = await api().get('/api/devices/available_extension');
      const options = extensions.data.map(extension => {
        return {
          value: extension._id,
          number: extension.number,
          label: extension.number
        };
      });

      options.sort((a, b) => {
        return String(a.number).localeCompare(String(b.number), undefined, {
          numeric: true,
          sensitivity: 'base'
        });
      });
      setOptionsExtensions([...options]);
    } catch (err) {
      console.error(err);
    } finally {
      setTimeout(() => setIsFetching(false), 1000);
    }
  };

  const getPauseStatus = async () => {
    try {
      setIsFetching(true);
      const status = await api().get('/api/status');
      const agentLoginId = '5972571dbe9d01feb20f45b7';
      const agentReadyId = '5972571dbe9d01feb20f45b6';
      const removeItems = [agentLoginId, agentReadyId];
      const options = status.data
        .filter(status => !removeItems.includes(status._id))
        .map(status => {
          return {
            value: status._id,
            name: status.name,
            label: (
              <span className="text-capitalize">
                &nbsp;
                <i className={status.icon} />
                &nbsp;&nbsp;{status.name}
              </span>
            )
          };
        });
      options.sort((a, b) => a.name.localeCompare(b.name));
      options.unshift({
        value: agentReadyId,
        name: 'disponível',
        label: (
          <span className="text-capitalize">
            &nbsp;
            <i className="fa fa-check" />
            &nbsp;&nbsp;disponível
          </span>
        )
      });
      setOptionsStatus([...options]);
    } catch (err) {
      console.error(err);
    } finally {
      setTimeout(() => setIsFetching(false), 1000);
    }
  };

  useEffect(() => {
    $('.sidebar-dropdown > a').click(function () {
      $('.sidebar-submenu').slideUp(200);
      if (
        $(this)
          .parent()
          .hasClass('active')
      ) {
        $('.sidebar-dropdown').removeClass('active');
        $(this)
          .parent()
          .removeClass('active');
      } else {
        $('.sidebar-dropdown').removeClass('active');
        $(this)
          .next('.sidebar-submenu')
          .slideDown(200);
        $(this)
          .parent()
          .addClass('active');
      }
    });
  }, []);

  useEffect(() => {
    getPauseStatus();
    getAvailableExtensions();
  }, []);

  useEffect(() => {
    try {
      const session = JSON.parse(localStorage.getItem('user'));
      if (session) {
        (async function () {
          const response = await api().get(`/api/users?_id=${session._id}`);
          const { status, data } = response;
          if (status === 200 && data && data[0]) {
            const user = { ...data[0] };
            dispatch(authenticationsCheckSession(user));
          }
        })();
      }
    } catch (err) {
      console.error('Error: ', err);
    }
  }, []);

  useEffect(() => {
    const { protocol, ipServerSKT, portServerSKT } = config;
    const socket = io(`${protocol}://${ipServerSKT}:${portServerSKT}`);
    try {
      const user = JSON.parse(localStorage.getItem('user'));
      let requestIsRunning = false;
      let timer = null;

      socket.on('connect', () => {
        console.log('socket sidebar conected ', socket.id);

        requestIsRunning = false;

        timer = setInterval(() => {
          const requestReports = {
            users: [user._id || '']
          };
          if (socket.connected && !requestIsRunning) {
            requestIsRunning = true;
            socket.emit('requestReports', {
              typeReports: Object.keys(requestReports),
              ...requestReports
            });
          }
        }, 1000);
      });

      socket.on('disconnect', () => {
        console.log('socket sidebar disconnected');
        clearInterval(timer);
      });

      socket.on('responseReports', data => {
        const groupEnabled = permissions.find(
          item => item.id === 'group' && item.enabled
        );
        const extensionEnabled = permissions.find(
          item => item.id === 'extension' && item.enabled
        );
        if (extensionEnabled || groupEnabled) {
          const { users } = data;
          const exts = users
            .map(usr => ({ id: usr._id, number: usr.extension }))
            .sort((a, b) => {
              return String(a.number).localeCompare(
                String(b.number),
                undefined,
                {
                  numeric: true,
                  sensitivity: 'base'
                }
              );
            });
          // Atualiza o select de ramais vinculados com o usuário
          if (
            users &&
            currentExtension.current &&
            users.length !== currentExtension.current.options.length
          ) {
            setExtensionsLogged([...exts]);
          } else if (users && currentExtension.current) {
            for (let i = 0; i < exts.length; i++) {
              if (
                exts[i].number !== currentExtension.current.options[i].value
              ) {
                setExtensionsLogged([...exts]);
                break;
              }
            }
          } else if (users && !currentExtension.current && exts.length) {
            setExtensionsLogged([...exts]);
          }
          const availableColor = 'rgb(22, 160, 133)';
          const unavailableColor = 'rgb(98, 98, 98)';
          const pauseColor = 'rgb(210, 77, 87)';
          const unavailableIcon = 'fa fa-window-close';
          const name = userName.current.innerHTML;
          const department = mainDptName.current.innerHTML;
          const client = clientNumber.current.innerHTML;
          const backColor = sidebarHeader.current.style.backgroundColor;
          if (users && users[0] && currentExtension.current) {
            const ext = currentExtension.current.value;
            const status = userStatus.current.innerHTML;
            const user = users.find(usr => usr.extension === ext);
            if (user) {
              const grps = user.groups
                .map(grp => ({
                  id: grp.groupId,
                  number: grp.group,
                  name: grp.name,
                  logged: grp.logged
                }))
                .sort((a, b) => {
                  return String(a.number).localeCompare(
                    String(b.number),
                    undefined,
                    {
                      numeric: true,
                      sensitivity: 'base'
                    }
                  );
                });
              // Atualiza os grupos disponiveis para login e logout
              if (
                grps &&
                grps.length !== groupsLoginLogout.current.childElementCount
              ) {
                setGroupsAvailable([...grps]);
              } else if (grps) {
                for (let i = 0; i < grps.length; i++) {
                  const { id, checked } = groupsLoginLogout.current.children[
                    i
                  ].firstChild;
                  if (grps[i].id !== id || grps[i].logged !== checked) {
                    setGroupsAvailable([...grps]);
                    break;
                  }
                }
              }
              // Atualiza os status de pausa
              const { value, options } = pauseSelected.current.props;
              if (
                options.length &&
                value &&
                user.idStatus &&
                value.value !== user.idStatus
              ) {
                setStatusId(user.idStatus);
              } else if (
                options.length &&
                !user.idStatus &&
                value.value !== avaliableAgentId
              ) {
                setStatusId(avaliableAgentId);
              }
              if (name !== user.userName) {
                userName.current.innerHTML = user.userName;
              }
              if (department !== user.department) {
                mainDptName.current.innerHTML = user.department;
              }
              if (client !== user.client) {
                clientNumber.current.innerHTML = user.client;
              }
              if (status.toLowerCase() !== user.status.toLowerCase()) {
                userStatus.current.innerHTML = user.status;
                icoStatus.current.className = user.icoStatus;
              }
              if (!user.idStatus && backColor !== unavailableColor) {
                icoStatus.current.className = unavailableIcon;
                sidebarHeader.current.style.backgroundColor = unavailableColor;
              } else if (
                user.idStatus === '5972571dbe9d01feb20f45b6' &&
                backColor !== availableColor
              ) {
                sidebarHeader.current.style.backgroundColor = availableColor;
              } else if (
                user.idStatus &&
                user.idStatus !== '5972571dbe9d01feb20f45b6' &&
                backColor !== pauseColor
              ) {
                sidebarHeader.current.style.backgroundColor = pauseColor;
              }
            }
          } else {
            if (name !== user.nameExtension) {
              userName.current.innerHTML = user.nameExtension;
            }
            if (department !== user.mainDptName) {
              const dptName = user.mainDptName
                ? user.mainDptName
                : sessionUser.department.name;
              mainDptName.current.innerHTML = dptName;
            }
            if (client !== '---') {
              clientNumber.current.innerHTML = '---';
            }
            if (backColor !== unavailableColor) {
              icoStatus.current.className = unavailableIcon;
              sidebarHeader.current.style.backgroundColor = unavailableColor;
              userStatus.current.innerHTML = 'indisponível';
            }
            if (
              groupsLoginLogout.current &&
              groupsLoginLogout.current.childElementCount
            ) {
              setGroupsAvailable([]);
            }
            if (pauseSelected.current) {
              const { value, options } = pauseSelected.current.props;
              if (options.length && value && value.value !== avaliableAgentId) {
                setStatusId(avaliableAgentId);
              }
            }
          }
          requestIsRunning = false;
        }
      });

      return () => {
        clearInterval(timer);
        socket.disconnect();
      };
    } catch (err) {
      console.error(err);
      socket.disconnect();
    }
  }, []);

  const disabledLinkPropagation = evt => {
    evt.preventDefault();
  };

  const LoginGroup = async ({ group, idGroup }) => {
    try {
      const extension = currentExtension.current.value;
      const idUser = JSON.parse(localStorage.getItem('user'))._id;
      if (extension && idUser && group && idGroup) {
        const obj = {
          group,
          extension,
          idUser,
          idExtension: '',
          idGroup,
          status: 'disponível'
        };
        for (const op of currentExtension.current.options) {
          if (op.value === extension) {
            obj.idExtension = op.id;
            break;
          }
        }
        await api().post('/api/group/login_group', obj);
      }
    } catch (err) {
      storeNotification.addNotification({
        ...notificationConfig,
        message: 'Falha ao executar login no grupo',
        type: 'danger'
      });
      console.error(err);
    } finally {
      setTimeout(() => setIsFetching(false), 2550);
    }
  };

  const LogoutGroup = async ({ group, idGroup }) => {
    try {
      const extension = currentExtension.current.value;
      if (extension && group && idGroup) {
        const obj = {
          group,
          extension,
          idExtension: '',
          idGroup
        };
        for (const op of currentExtension.current.options) {
          if (op.value === extension) {
            obj.idExtension = op.id;
            break;
          }
        }
        await api().post('/api/group/logout_group', obj);
      }
    } catch (err) {
      storeNotification.addNotification({
        ...notificationConfig,
        message: 'Falha ao executar logout no grupo',
        type: 'danger'
      });
      console.error(err);
    } finally {
      setTimeout(() => setIsFetching(false), 2550);
    }
  };

  const handleChangeLoginLogoutGroup = evt => {
    evt.preventDefault();
    const { checked, id, name } = evt.target;
    if (checked) {
      const { value } = pauseSelected.current.props;
      if (value.value === avaliableAgentId) {
        LoginGroup({ group: name, idGroup: id });
        setIsFetching(true);
      }
    } else {
      LogoutGroup({ group: name, idGroup: id });
      setIsFetching(true);
    }
  };

  const handleChangeStatusPause = async evt => {
    try {
      setIsFetching(true);
      const { value } = evt;
      const extension = currentExtension.current.value;
      const newStatus = optionsStatus.find(status => status.value === value);
      if (value !== statusId && extension && newStatus) {
        const obj = {
          extension,
          status: newStatus.name.toLowerCase(),
          idUser: JSON.parse(localStorage.getItem('user'))._id,
          type: newStatus.value === avaliableAgentId ? 'ready' : 'notReady',
          idStatus: newStatus.value
        };
        await api().post('/api/group/ready_notready_group', obj);
      }
    } catch (err) {
      storeNotification.addNotification({
        ...notificationConfig,
        message: 'Falha ao executar a troca de status',
        type: 'danger'
      });
      console.error(err);
    } finally {
      setTimeout(() => setIsFetching(false), 2550);
    }
  };

  const extensionLogout = async (id, number) => {
    try {
      setIsFetching(true);
      const obj = {
        extension: number,
        idExtension: id
      };
      await api().post('/api/devices/logout_extension', obj);
    } catch (err) {
      storeNotification.addNotification({
        ...notificationConfig,
        message: 'Falha ao deslogar do ramal',
        type: 'danger'
      });
      console.error(err);
    } finally {
      setTimeout(() => getAvailableExtensions(), 1550);
    }
  };

  const handleChangeSelectLoginRamal = ({ value, number }) => {
    if (
      value &&
      number &&
      value !== extensionToLogin.id &&
      number !== extensionToLogin.number
    ) {
      setExtensionToLogin({ id: value, number });
    }
  };

  const handleClickLoginRamal = async () => {
    try {
      const idUser = JSON.parse(localStorage.getItem('user'))._id;
      if (idUser && extensionToLogin.id && extensionToLogin.number) {
        setIsFetching(true);
        const obj = {
          extension: extensionToLogin.number,
          idExtension: extensionToLogin.id,
          idUser
        };
        await api().post('/api/devices/login_extension', obj);
        const newOptions = optionsExtensions.filter(
          ext => ext.value !== extensionToLogin.id
        );
        setOptionsExtensions([...newOptions]);
      }
    } catch (err) {
      storeNotification.addNotification({
        ...notificationConfig,
        dismiss: {
          duration: 4100,
          showIcon: true
        },
        message:
          'Falha ao logar no ramal, verifique se está em uso por outro operador e tente novamente.',
        type: 'danger'
      });
      getAvailableExtensions();
      console.error(err);
    } finally {
      setExtensionToLogin({ ...defaultValueSelectExtension });
      setTimeout(() => setIsFetching(false), 2550);
    }
  };

  const handleClickTab = key => {
    if (parseInt(localStorage.getItem('tab')) !== parseInt(key)) {
      setExtensionToLogin({ ...defaultValueSelectExtension });
    }
    localStorage.setItem('tab', key);
    if (parseInt(key) === 4) {
      handleClickUpdateTableCallHistory(setIsFetching, setTableDataCallHistory);
    }
  };

  return (
    <nav className="sidebar-wrapper">
      <ModalChangePassword
        showModal={showModalChangePassword}
        handleModalClose={handleModalCloseChangePassword}
        user={sessionUser._id}
      />
      <ModalChangeImage
        showModal={showModalChangeImage}
        handleModalClose={handleModalCloseChangeImage}
        user={sessionUser._id}
        title={sessionUser.name}
      />
      <div className="sidebar-content">
        <div
          className="sidebar-item sidebar-header d-flex flex-nowrap"
          style={{ backgroundColor: 'rgb(98, 98, 98)' }}
          ref={sidebarHeader}
        >
          <div
            className="user-pic"
            onClick={() => setShowModalChangeImage(true)}
            onMouseOver={() => {
              editIcon.current.style.display = 'inline';
            }}
            onMouseLeave={() => {
              editIcon.current.style.display = 'none';
            }}
          >
            <span className="fa fa-edit fa-2x" ref={editIcon}></span>
            <img
              className="img-responsive"
              title="Trocar Foto"
              src={`${config.protocol}://${config.ipServerGW}:${config.portServerGW}/api/users/image/${sessionUser._id}?key=${imageKey}`}
              alt="Avatar"
            />
          </div>
          <div className="user-info">
            <span className="user-status" title="Usuário">
              <i className="fa fa-user" />
              <strong ref={userName}>Operador</strong>
            </span>
            <span className="user-status" title="Departamento">
              <i className="fa fa-building" />
              <span ref={mainDptName}>Unidade</span>
            </span>
            <span className="user-status" title="Status do Usuário">
              <i className="fa fa-window-close" ref={icoStatus} />
              <span className="text-capitalize" ref={userStatus}>
                indisponível
              </span>
            </span>
            <span className="user-status" title="Número do Cliente">
              <i className="fa fa-phone" />
              <span ref={clientNumber}>---</span>
            </span>
          </div>
          <span className="sidebar-change-passwd" title="Trocar Senha">
            <button
              type="button"
              className="btn btn-sm btn-dark"
              onClick={() => setShowModalChangePassword(true)}
            >
              <i className="fa fa-key" />
            </button>
          </span>
        </div>
        <div className="sidebar-menu">
          <Tabs
            defaultActiveKey={localStorage.getItem('tab') || '1'}
            id="uncontrolled-tab-example"
            className="tema"
            onSelect={handleClickTab}
          >
            {permissions
              .filter(obj => obj.enabled)
              .map((obj, i) => {
                return (
                  <Tab
                    key={i}
                    eventKey={i + 1}
                    title={
                      <span>
                        <i className={obj.icon} />
                      </span>
                    }
                  >
                    <ul className="sidebar-text">
                      <li className="header-menu">
                        <span>{obj.tab}</span>
                      </li>
                      {obj.id === 'mainMenu' &&
                        obj.items.length > 0 &&
                        obj.items
                          .filter(menu => menu.enabled)
                          .map((menu, i) => {
                            return (
                              <li
                                key={i}
                                className={
                                  menu.submenu ? 'sidebar-dropdown' : ''
                                }
                              >
                                {menu.link === '#' ? (
                                  <Link
                                    to={menu.link}
                                    onClick={disabledLinkPropagation}
                                  >
                                    <i className={menu.icon} />
                                    <span>{menu.title}</span>
                                  </Link>
                                ) : (
                                  <Link to={menu.link}>
                                    <i className={menu.icon} />
                                    <span>{menu.title}</span>
                                  </Link>
                                )}
                                {menu.submenu && menu.items.length > 0 && (
                                  <div className="sidebar-submenu">
                                    <ul>
                                      {menu.items
                                        .filter(submenu => {
                                          return (
                                            submenu.enabled &&
                                            !(
                                              submenu.id === 'companies' &&
                                              sessionUser.permissionsGroup
                                                ._id !== idPermissionsGroup4Case
                                            )
                                          );
                                        })
                                        .map((submenu, i) => {
                                          return (
                                            <li key={i}>
                                              <Link to={submenu.link}>
                                                <i className={submenu.icon} />
                                                <span>{submenu.title}</span>
                                              </Link>
                                            </li>
                                          );
                                        })}
                                    </ul>
                                  </div>
                                )}
                              </li>
                            );
                          })}
                      {obj.id === 'group' && (
                        <Group
                          currentExtension={currentExtension}
                          extensionsLogged={extensionsLogged}
                          groupsLoginLogout={groupsLoginLogout}
                          handleChangeLoginLogoutGroup={
                            handleChangeLoginLogoutGroup
                          }
                          optionsStatus={optionsStatus}
                          handleChangeStatusPause={handleChangeStatusPause}
                          isFetching={isFetching}
                          groupsAvailable={groupsAvailable}
                          statusId={statusId}
                          pauseSelected={pauseSelected}
                          getPauseStatus={getPauseStatus}
                        />
                      )}
                      {obj.id === 'extension' && (
                        <Extension
                          isFetching={isFetching}
                          optionsExtensions={optionsExtensions}
                          extensionToLogin={extensionToLogin}
                          handleChangeSelectLoginRamal={
                            handleChangeSelectLoginRamal
                          }
                          getAvailableExtensions={getAvailableExtensions}
                          handleClickLoginRamal={handleClickLoginRamal}
                          extensionsLogged={extensionsLogged}
                          extensionLogout={extensionLogout}
                        />
                      )}
                      {obj.id === 'callHistory' && (
                        <CallHistory
                          isFetching={isFetching}
                          setIsFetching={setIsFetching}
                          tableDataCallHistory={tableDataCallHistory}
                          setTableDataCallHistory={setTableDataCallHistory}
                        />
                      )}
                    </ul>
                  </Tab>
                );
              })}
          </Tabs>
        </div>
      </div>
    </nav>
  );
};

export default Sidebar;
